/* import __COLOCATED_TEMPLATE__ from './individual-address.hbs'; */
import Component from '@glimmer/component';
import { feature } from '@square/ember-features/macros';

export default class IndividualAddressComponent extends Component {
  @feature('banking/stop_prefilling_savings_onboarding')
  declare stopPrefilling: boolean;

  get confirmLink(): string {
    return this.stopPrefilling
      ? 'signup.enter-business-info'
      : 'signup.confirm-identity.index';
  }

  get editLink(): string {
    return this.stopPrefilling
      ? 'signup.enter-identity-info'
      : 'signup.confirm-identity.edit';
  }
}
